// --- helpers ----------------------------------------------------

// Create / reuse a fixed host in the bottom-left corner
function ensureHost() {
  if (window.__popupHost) return window.__popupHost;

  const host = document.createElement('div');
  host.style.position = 'fixed';
  host.style.left = '20px';
  host.style.bottom = '20px';
  host.style.zIndex = '9999';
  host.style.pointerEvents = 'none';
  host.style.display = 'flex';
  host.style.flexDirection = 'column';
  host.style.gap = '10px';

  document.body.appendChild(host);
  window.__popupHost = host;
  return host;
}

function getRoot() {
  const host = ensureHost();
  if (!host._root) {
    host._root = host; // no shadow DOM, simpler

    const style = document.createElement("style");
    style.textContent = `
      * { box-sizing: border-box; }
      .card {
        pointer-events: auto;
        display: flex; align-items: flex-start; gap: 10px;
        padding: 12px 14px; border-radius: 12px;
        background: #fff; color: #111;
        max-width: min(92vw, 560px);
        min-width: 260px;
        box-shadow: 0 10px 28px rgba(0,0,0,0.18);
        font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
        font-size: 14px; line-height: 1.35;
        animation: fadeIn 180ms ease-out;
        will-change: opacity, transform;
        contain: content;
      }
      .link { text-decoration: none; color: inherit; display: flex; gap: 10px; width: 100%; }
      .flag { flex: none; font-size: 18px; line-height: 1; margin-top: 2px; }
      .text {
        display: block;
        white-space: normal;
        overflow: visible;
        word-break: break-word;
      }
      b { font-weight: 600; }
      @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes fadeOut { to { opacity: 0; transform: translateY(6px); } }
    `;
    host._root.appendChild(style);
  }
  return host._root;
}

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, m => ({
    '&':'&amp;',
    '<':'&lt;',
    '>':'&gt;',
    '"':'&quot;',
    "'":'&#39;'
  }[m]));
}

// Fallback countries list if none defined elsewhere
if (typeof window.countries === 'undefined') {
  window.countries = [
    { name: 'Finland', flag: '🇫🇮' },
    { name: 'Sweden',  flag: '🇸🇪' },
    { name: 'Norway',  flag: '🇳🇴' },
    { name: 'Germany', flag: '🇩🇪' },
    { name: 'France',  flag: '🇫🇷' },
  ];
}

// --- main popup function ----------------------------------------

function showPopup(product) {
  const root = getRoot();
  const countries = window.countries;
  const country = countries[Math.floor(Math.random() * countries.length)];

  const baseTemplate =
    (window.popupTemplate && String(window.popupTemplate)) ||
    "Someone from %country% added %product% to cart";

  let rendered = baseTemplate
    .replace("%country%", escapeHtml(country.name))
    .replace("%product%", escapeHtml(product.title));

  rendered = rendered
    .replace(escapeHtml(country.name), `<b>${escapeHtml(country.name)}</b>`)
    .replace(escapeHtml(product.title), `<b>${escapeHtml(product.title)}</b>`);

  const card = document.createElement("div");
  card.className = "card";

  const a = document.createElement("a");
  a.className = "link";
  a.href = `/products/${encodeURIComponent(product.handle)}`;

  const flag = document.createElement("span");
  flag.className = "flag";
  flag.textContent = country.flag;

  const text = document.createElement("span");
  text.className = "text";
  text.innerHTML = rendered;

  a.appendChild(flag);
  a.appendChild(text);
  card.appendChild(a);
  root.appendChild(card);

  setTimeout(() => {
    card.style.animation = "fadeOut 300ms ease-in forwards";
  }, 4200);
  setTimeout(() => {
    card.remove();
  }, 4600);
}

// --- auto popup loop --------------------------------------------

function getRandomPopupProduct() {
  if (Array.isArray(window.popupProducts) && window.popupProducts.length) {
    const product = window.popupProducts[
      Math.floor(Math.random() * window.popupProducts.length)
    ];
    console.log('Using real product for popup:', product);
    return product;
  }

  console.log('Using fallback test product for popup');
  return {
    handle: 'test-product',
    title: 'Test Product'
  };
}

function schedulePopupLoop() {
  const delay = 15000 + Math.random() * 20000;

  setTimeout(() => {
    try {
      const product = getRandomPopupProduct();
      showPopup(product);
    } catch (e) {
      console.error('Error showing popup:', e);
    }

    schedulePopupLoop();
  }, delay);
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(schedulePopupLoop, 8000);
});
